// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:24
import { CrisisSimpleCallCard_abstract } from './../abstract/SagaSchema/CrisisSimpleCallCard_abstract';
export class CrisisSimpleCallCard extends CrisisSimpleCallCard_abstract {}
